export default __webpack_public_path__ + "static/media/ALLEGATO 1 - POLITICA_ANTICORRUZIONE_ISO_37001-rev 1.81d5de1a.pdf";